<template>
  <div id="action-company">
    <button-icon
        v-if="!ehRascunho"
        color="#2772C0"
        size="18"
        feather-icon="EyeIcon"
        @action="verAdesao"
    />
    <button-icon
        v-if="ehRascunho"
        color="#2772C0"
        size="18"
        feather-icon="EditIcon"
        @action="editarPedido"
    />
    <button-icon
        v-if="ehRascunho"
        color="#2772C0"
        size="18"
        feather-icon="Trash2Icon"
        @action="deletarPedido"
    />
    <ExcluirPedidoModal
        :Pedido="pedidoAcao"
        v-if="pedidoAcao != null"
        @fecharModalExclucaoPedido="fecharModalExclusaoPedido"
        @fecharModalRetorno="fecharModalRetorno"
    />
  </div>
</template>

<script>
import ButtonIcon from "@/views/components/custom/Buttons/ButtonIcon/ButtonIcon";
import {
  AdesaoSetChooseOrderAdhesion
} from "@/views/custom-pages/adesao/Purchase/adesaoHelpers.js";
import $router from "@/router";
import ExcluirPedidoModal from "@/views/custom-pages/adesao/components/ExcluirPedidoModal/ExcluirPedidoModal.vue";

export default {
  props: {
    Order: {
      required: true,
    },
  },
  data() {
    return {
      pedidoSelecionado: null,
    };
  },
  components: {
    ExcluirPedidoModal,
    ButtonIcon,
  },
  methods: {
    verAdesao() {
      AdesaoSetChooseOrderAdhesion(this.Order);
    },
    editarPedido() {
      this.setDadosCompanyAndCampaign();
    },
    deletarPedido() {
      this.pedidoSelecionado = this.Order;
    },
    fecharModalExclusaoPedido() {
      this.pedidoSelecionado = null;
    },
    fecharModalRetorno() {
      this.$emit("deleted");
    },
    async setDadosCompanyAndCampaign() {
      $router.push({name: "purchase", params: {idPedido: this.Order.id_pedido}})
    },
  },
  computed: {
    ehRascunho() {
      return this.Order.pedido_situacao == "Rascunho";
    },
    pedidoAcao() {
      return this.pedidoSelecionado;
    },
  },
};
</script>
